'use client';
import { Button } from '@vs-shop/ui/button';
import { Delete } from 'lucide-react';
import { useIntl } from 'react-intl';

import { clearProductCodesAtom } from '@vs-shop/engine/atom/productsComparison/productsComparison';
import { useAtomSet } from '@effect/atom-react';

export default function ProductComparisonFooterClearAll() {
  const intl = useIntl();
  const clearComparisonProductCodes = useAtomSet(clearProductCodesAtom);

  const handleClearComparisonProductCodes = () => {
    clearComparisonProductCodes();
  };

  return (
    <Button onClick={handleClearComparisonProductCodes} className="gap-4">
      <Delete className="size-6 shrink-0 rotate-180" />
      <span className="leading-none uppercase">
        {intl.formatMessage({
          id: 'product.comparison.footer.clearAll',
          defaultMessage: 'Vše vymazat',
        })}
      </span>
    </Button>
  );
}
